import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GroupementCriteres } from 'src/app/utils/interfaces/new/GroupementCriteres';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { TexteModele } from 'src/app/utils/interfaces/new/TexteModele';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class GroupementCriteresService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath + '/personnalisation/';

  constructor(
    private _http: HttpClient,
    private _snack: SnackbarService
  ) { }

  async findGroupementCriteresList(): Promise<GroupementCriteres[]> {
    try {
      const res = await this._http.get(this.apiUri + 'groupement-criteres', this.httpOptions).toPromise();
      const refs = res.body as GroupementCriteres[];
      return refs;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async findOneGroupementCriteres(idGroupement: string): Promise<GroupementCriteres> {
    try {
      const res = await this._http.get(this.apiUri + 'groupement-criteres/' + idGroupement, this.httpOptions).toPromise();
      const refs = res.body as GroupementCriteres;
      return refs;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async addGroupementCriteres(groupement: GroupementCriteres) {
    try {
      return await this._http.post(this.apiUri + 'groupement-criteres', groupement, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async updateGroupementCriteres(groupement: GroupementCriteres) {
    try {
      return await this._http.put(this.apiUri + 'groupement-criteres/' + groupement.id, groupement, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async deleteGroupementCriteres(idGroupement: string) {
    try {
      return await this._http.delete(this.apiUri + 'groupement-criteres/' + idGroupement, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
